/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
const Badges = r => require.ensure([], () => r(require('./components/badges')), 'setting');
const Points = r => require.ensure([], () => r(require('./components/points')), 'setting');
const addBadge = r => require.ensure([], () => r(require('./components/add_badge')), 'setting');
const awardLog = r => require.ensure([], () => r(require('./components/award_log')), 'setting');
const gamification_notification = r => require.ensure([], () => r(require('./components/gamification_notification')), 'setting');

export default [
    {
        name: 'gamification.badges',
        path: '/gamification-engine/badges',
        component: Badges,
    },
    {
        name: 'gamification.add_badge',
        path: '/gamification-engine/add-badge',
        component: addBadge,
    },
    {
        name: 'gamification.edit_badge',
        path: '/gamification-engine/edit-badge/:id',
        component: addBadge,
    },
    {
        name: 'gamification.points',
        path: '/gamification-engine/points',
        component: Points,
    },
    {
        name: 'gamification.award_log_all',
        path: '/gamification-engine/award-log/',
        component: awardLog,
    },
    {
        name: 'gamification.award_log',
        path: '/gamification-engine/award-log/:id/',
        component: awardLog,
    },
    {
        name: 'gamification.gamification_notification',
        path: '/gamification-engine/default-notification-email-settings',
        component: gamification_notification,
    },
]



// WEBPACK FOOTER //
// ./src/app/gamification/routes.js